module.exports = __webpack_public_path__ + "img/badge-list-thumb-084.90388957.png";